import {useState, useEffect} from "react";
import {
    Container, 
    Button, 
    Table, 
    TableHead, 
    TableBody, 
    TableFooter,
    Grid,
    Modal,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl
} from "@material-ui/core";

import { DataGrid,
    ptBR
} from '@mui/x-data-grid';

import Pagination from '@material-ui/lab/Pagination';
import { toast  } from 'react-toastify';
import Olho from "@material-ui/icons/RemoveRedEye"
import api from "../../services/api";
import { pode, mensagemErro } from "../../services/acesso";
import { baixarArquivo } from "../../services/download";
import {StyledTableCell,StyledTableRow, useStyles} from '../mailing/ListingMailing/styles';
import {Link} from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { LinearProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FILTROS_VAZIOS, DATA_MIN, DATA_MAX, validarFiltros, montarParams } from "./filtrosAgendamento";

const columns = [
    {
        field: 'actions',
        headerName: 'Ações',
        renderCell: RowMenuCell,
        sortable: false,
        width: 100,
        headerAlign: 'center',
        filterable: false,
        align: 'center',
        disableColumnMenu: true,
        disableReorder: true,
    },
    { 
        field: 'numero_reuniao', 
        headerName: 'Número Reunião', 
        width: 250,
        filterable: false,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'tipo_agenda_label',
        headerName: 'Tipo',
        width: 150,
        filterable: false,
        disableReorder: true,
        sortable: false,
    },
    {
        field: 'data_reuniao', 
        headerName: 'Data Reunião', 
        width: 250,
        type: "date",
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'hora_reuniao', 
        headerName: 'Hora Reunião', 
        width: 250,
        disableReorder: true,
        sortable: false,
        // A API devolve HH:MM:SS; a tela mostra HH:MM.
        valueFormatter: (params) => (params.value ? String(params.value).slice(0, 5) : ""),
    },
    { 
        field: 'customersName', 
        headerName: 'Cliente', 
        filterable: false,
        width: 250,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'corporate_name', 
        headerName: 'Razão Social', 
        filterable: false,
        width: 250,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'cargo', 
        headerName: 'Cargo do contato', 
        filterable: false,
        width: 250,
        disableReorder: true,
        sortable: false,

    },
    
    { 
        field: 'cnae', 
        headerName: 'CNAE', 
        filterable: false,
        width: 250,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'data_agendamento', 
        headerName: 'Data Agendamento',
        width: 250,
        type: "date",
        disableReorder: true,
        sortable: false,


    },
    { 
        field: 'status_auditoria', 
        headerName: 'Status Auditoria', 
        width: 250,
        filterable: false,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'status', 
        headerName: 'Status Agendamento', 
        width: 250,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'enviou_briefing', 
        headerName: 'Status Briefing', 
        width: 250,
        filterable: false,
        disableReorder: true,
        sortable: false,

    },
    { 
        field: 'assessoresName', 
        headerName: 'Assessor', 
        width: 250,
        disableReorder: true,
        sortable: false,

    }
    
];



function RowMenuCell(props) {
    const { api : apiTable, id, row} = props;
    const classes = useStyles();
    const [confirmOpen,setConfirmOpen] = useState(false);

    const handleDeleteClick = (event) => {
        // event.stopPropagation();

        api.delete(`agendamento-lead/${id}`).then(res => {
            console.log(res)
            apiTable.updateRows([{ id, _action: 'delete' }]);
        }).catch(error => {
            console.log(error)
        })

        
    };
    
      
    return (
      <div className={classes.root}>
        <Link to={"/agendamento-lead/"+row.idAgendamento+"?id_lead="+row.lead_id}>
            <IconButton>
                <EditIcon/>
            </IconButton>
        </Link>
        {pode("excluir") && (
        <IconButton
          color="inherit"
          size="small"
          aria-label="delete"
          onClick={() => setConfirmOpen(true)}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
        )}
        <ConfirmDialog
            title="Excluir agenda?"
            open={confirmOpen}
            setOpen={setConfirmOpen}
            onConfirm={handleDeleteClick}
        >
           Tem certeza de que deseja excluir?
        </ConfirmDialog>
      </div>
    );
}


const ConfirmDialog = (props) => {
  const { title, children, open, setOpen, onConfirm } = props;
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => setOpen(false)}
          color="secondary"
        >
          Não
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            setOpen(false);
            onConfirm();
          }}
          color="default"
        >
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const AgendamentoLead = () => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [customers, setCustomers] = useState([]);
    const [assessores, setAssessores] = useState([]);

    // "form" = o que está digitado; "aplicados" = o que foi pesquisado.
    // A paginação usa sempre os aplicados, para não misturar filtro digitado e não pesquisado.
    const [form, setForm] = useState(FILTROS_VAZIOS);
    const [aplicados, setAplicados] = useState(FILTROS_VAZIOS);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(50);
    const [filters, setFilters] = useState([]);

    const alterar = (campo) => (valor) => setForm((atual) => ({ ...atual, [campo]: valor }));

    useEffect(() => {
        //clientes
        (async () => {
            let data = await api.get("customers", {
                params: {
                    pageSize: 99999,
                }
            });
            setCustomers(data?.data.data);
        })();

        //assessores
        (async () => {
            try {
                let data = await api.get("assessor/get/select");
                setAssessores(data.data);
            } catch(e) {
                console.log(e);
            }
        })();
        
    }, []);


    useEffect(() => {
        getAgendamentos();
    }, [page, filters, aplicados]);

    function handlePage(value) {
        setPage(value);
    }

    async function getAgendamentos() {
        try {
            setLoading(true)

            let data = await api.get(`agendamento-lead/listing`, {
                params: montarParams(aplicados, page, filters, localStorage.getItem("id_assessor"))
            });
            setRows(data.data.data);
            setTotal(data.data.total);
            setPageSize(data.data.per_page);
        } catch(exception) {
            toast.error(mensagemErro(exception, "Não foi possível carregar as reuniões"));
        } finally {
            setLoading(false)
        }
    }

    // Pesquisar sempre volta para a primeira página.
    function pesquisar() {
        const erro = validarFiltros(form);
        if (erro) {
            toast.warning(erro);
            return;
        }
        setPage(0);
        setAplicados({ ...form });
    }

    function limpar() {
        setForm(FILTROS_VAZIOS);
        setPage(0);
        setAplicados(FILTROS_VAZIOS);
    }

    const onFilterChange = (filterModel) => {
        setPage(0);
        setFilters(filterModel.items)
    };


    const exportAgenda = async () => {
        setLoading(true)
        try {
            await baixarArquivo("agenda-export", "agendas.xlsx");
        } catch (erro) {
            toast.error(erro.message || "Não foi possível exportar as agendas");
        } finally {
            setLoading(false)
        }
    }

    return (
        <Container>
            <h1>Agendamento de Leads</h1>
            <div
                  style={{
                    borderRadius: "5px",
                    borderLeftWidth: "1px",
                    borderRightWidth: "1px",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    backgroundColor:"#fff",
                    padding:"10px",
                    paddingBottom:"10px",
                    marginBottom: "20px"
                  }}
                >
                <Container>
                  <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <TextField  
                                id="filtro-reuniao-de"
                                label="Reunião de"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.reuniaoDe}
                                onChange={evt => alterar("reuniaoDe")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                id="filtro-reuniao-ate"
                                label="Reunião até"
                                fullWidth 
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.reuniaoAte}
                                onChange={evt => alterar("reuniaoAte")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                id="filtro-agendamento-de"
                                label="Agendamento de"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.agendamentoDe}
                                onChange={evt => alterar("agendamentoDe")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                id="filtro-agendamento-ate"
                                label="Agendamento até"
                                fullWidth
                                type={"date"}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: DATA_MIN, max: DATA_MAX }}
                                value={form.agendamentoAte}
                                onChange={evt => alterar("agendamentoAte")(evt.target.value)}
                                />
                        </Grid>
                        <Grid item xs={3}>
                            <Autocomplete
                            disablePortal
                            id="Clientes"
                            options={customers}
                            onChange={(event, newInputValue) => {
                                alterar("cliente")(newInputValue);
                            }}
                            value={form.cliente}
                            getOptionLabel={(option) => option.name || ""}
                            renderInput={(params) => <TextField {...params} label="Cliente" />}
                        />
                        </Grid>
                        <Grid item xs={3}>
                            <Autocomplete
                            disablePortal
                            id="Assessores"
                            options={assessores}
                            onChange={(event, newInputValue) => {
                                alterar("assessor")(newInputValue);
                            }}
                            value={form.assessor}
                            getOptionLabel={(option) => option.name || ""}
                            renderInput={(params) => <TextField {...params} label="Assessor" />}
                        />
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel id="filtro-tipo-label">Tipo</InputLabel>
                                <Select
                                    labelId="filtro-tipo-label"
                                    id="filtro-tipo"
                                    value={form.tipoAgenda}
                                    onChange={evt => alterar("tipoAgenda")(evt.target.value)}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    <MenuItem value="1">Reunião</MenuItem>
                                    <MenuItem value="0">Oportunidade</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel id="filtro-auditoria-label">Status Auditoria</InputLabel>
                                <Select
                                    labelId="filtro-auditoria-label"
                                    id="status_auditoria"
                                    value={form.statusAuditoria}
                                    onChange={evt => alterar("statusAuditoria")(evt.target.value)}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    <MenuItem value={"em_branco"}>Em Branco</MenuItem>
                                    <MenuItem value={"2"}>Aguardando</MenuItem>
                                    <MenuItem value={"1"}>Aprovada</MenuItem>
                                    <MenuItem value={"3"}>Não Aprovado</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel id="filtro-confirmacao-label">Status Confirmação</InputLabel>
                                <Select
                                    labelId="filtro-confirmacao-label"
                                    id="status_confirmacao"
                                    value={form.statusConfirmacao}
                                    onChange={evt => alterar("statusConfirmacao")(evt.target.value)}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    <MenuItem value="em_branco">Em Branco</MenuItem>
                                    <MenuItem value="aguardando">Aguardando</MenuItem>
                                    <MenuItem value="confirmado">Confirmada</MenuItem>
                                    <MenuItem value="realizada">Realizada</MenuItem>
                                    <MenuItem value="reagendada">Reagendada</MenuItem>
                                    <MenuItem value="declinada">Declinada</MenuItem>
                                    <MenuItem value="aguardando_nova_data">Aguardando nova data</MenuItem>
                                    <MenuItem value="nao_aprovada">Não aprovada</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth>
                                <InputLabel id="filtro-briefing-label">Status Briefing</InputLabel>
                                <Select
                                    labelId="filtro-briefing-label"
                                    id="enviou_briefing"
                                    value={form.statusBriefing}
                                    onChange={evt => alterar("statusBriefing")(evt.target.value)}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    <MenuItem value={"em_branco"}>Em Branco</MenuItem>
                                    <MenuItem value={"0"}>Aguardando</MenuItem>
                                    <MenuItem value={"1"}>Enviado</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button onClick={pesquisar} variant="contained" style={{color:"#4B8B33"}}>
                                PESQUISAR
                            </Button>
                            <Button onClick={limpar} variant="text" style={{color:"#4B8B33", marginLeft: "10px"}}>
                                LIMPAR
                            </Button>
                        </Grid>
                  </Grid>
                </Container>
            </div>
            <div style={{marginBottom: "10px"}}>
                {pode("editar_reunioes") && (
                <Link to={"/agendamento-lead/novo"} style={{ textDecoration: 'inherit'}}>
                    <Button variant="contained" style={{color:"#4B8B33"}} href="#contained-buttons">
                        NOVO
                    </Button>
                </Link>
                )}
                {
                     pode("exportar") ?   <Button variant="contained" style={{color:"#4B8B33", marginLeft: "10px"}} onClick={() => exportAgenda()}>
                     EXPORTAR
                    </Button> : ""
                }
              
            </div>
            {loading && <div style={{width: "100%"}}>
                <LinearProgress/>
            </div>}
            
            <div style={{ height: 600, width: '100%', paddingTop: "10px" }}>

                <DataGrid
                    pagination
                    rowCount={total}
                    style={{paddingTop:20}}
                    rows={rows} 
                    page={page}
                    pageSize={pageSize}
                    loading={loading}
                    columns={columns} 
                    rowsPerPageOptions={[pageSize]}
                    localeText={ptBR.props.MuiDataGrid.localeText}
                    paginationMode="server"
                    filterMode="server"
                    onPageChange={handlePage}
                    onFilterModelChange={onFilterChange}
                />   
            </div>

            {/* <Table>
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCell>Data da Reunião</StyledTableCell>
                        <StyledTableCell>Cliente</StyledTableCell>
                        <StyledTableCell>Data da Agendamento</StyledTableCell>
                        <StyledTableCell>Status (auditoria)</StyledTableCell>
                        <StyledTableCell>Status (confirmação)</StyledTableCell>
                        <StyledTableCell>Ações</StyledTableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody>
                    {rows.map(row => (
                        <StyledTableRow key={row.idAgendamento}>
                            <StyledTableCell>{row.data_reuniao}</StyledTableCell>
                            <StyledTableCell>{row.customersName}</StyledTableCell>
                            <StyledTableCell>{row.data_agendamento}</StyledTableCell>
                            <StyledTableCell>{row.status_auditoria ? row.status_auditoria : "Em Branco"}</StyledTableCell>                        
                            <StyledTableCell>{row.statusAgendamento ? row.statusAgendamento : "Em Branco"}</StyledTableCell>    
                            <StyledTableCell>
                                <Link to={"/agendamento-lead/"+row.idAgendamento+"?id_lead="+row.lead_id}>
                                    <Button variant={"contained"} color={"default"}>
                                        <Olho/>
                                    </Button>
                                </Link>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
                <TableFooter>
                <div style={{textAlign:"center",paddingTop:"10px",paddingBottom:"10px"}}>
                    <Pagination style={{textAlign:"center"}} count={total} page={page} onChange={handlePage} />
                </div>
                </TableFooter>
            </Table> */}
        </Container>
    )
}

export default AgendamentoLead;